exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  display: -ms-flexbox;\n  display: flex;\n  padding: var(--padding);\n  gap: var(--padding);\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  form h2,\n  form .center {\n    width: 100%; }\n  form app-image-input {\n    max-width: 50rem; }\n  form fieldset {\n    display: -ms-grid;\n    display: grid;\n    gap: var(--padding);\n    border-width: 0;\n    -ms-grid-columns: max-content auto;\n        grid-template-columns: max-content auto; }\n    form fieldset:not(.color) {\n      width: 100%; }\n    form fieldset.color {\n      min-width: 30%;\n      -ms-grid-columns: max-content 5rem min-content;\n          grid-template-columns: max-content 5rem min-content; }\n    form fieldset legend {\n      -ms-grid-column-span: 3;\n      -ms-grid-column: auto;\n          grid-column: auto / span 3;\n      font-weight: bold; }\n    form fieldset label {\n      text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/brand/brand-edit/brand-edit.component.scss
// module id = ../../../../../src/app/brand/brand-edit/brand-edit.component.scss
// module chunks = main